import { logoLinksSearchStyles as styles } from "@insite/content-library/Widgets/Header/LogoLinksSearch";
import { gutter, mediaQueriesBP } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        align-items: center;
        padding: 24px ${gutter}px 5px;

        ${mediaQueriesBP.minMD} {
            padding: 24px ${gutter}px;
        }
    `,
};

styles.logoWrapper = {
    ...styles.logoWrapper,
    css: css`
        ${styles.logoWrapper?.css}
        margin: 0;
        padding: 0;

        img {
            min-height: 70px;

            ${mediaQueriesBP.minMD} {
                min-width: 245px;
                min-height: 115px;
                object-fit: contain;
                aspect-ratio: 16/9;
            }
        }
    `,
};

styles.searchMenuWrapper = {
    ...styles.searchMenuWrapper,
    css: css`
        ${styles.searchMenuWrapper?.css}
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
